import http from '@/http-common';

class PermissionValidatorService {
  async valPermissaoWithException(inputModel) {
    return http.post('/permissionValidator/valPermissaoWithException', inputModel);
  }

  async valPermissaoNegativaBoolean(inputModel) {
    return http.post('/permissionValidator/valPermissaoNegativaBoolean', inputModel);
  }

  async valPermissao(inputModel) {
    return http.post('/permissionValidator/valPermissao', inputModel);
  }

  async valPermissaoNegativaWithExceptionForbidden(inputModel) {
    return http.post('/permissionValidator/valPermissaoNegativaWithExceptionForbidden', inputModel);
  }

  async valPermissaoObrigatoriedade(inputModel) {
    return http.post('/permissionValidator/valPermissaoObrigatoriedade', inputModel);
  }
}

export default new PermissionValidatorService();
